import React from 'react';
import type { ButtonHTMLAttributes, FC, ReactNode } from 'react';
import { cx } from '../../../utils/cx';
import styles from './Button.module.scss';

export type ButtonVariant = 'default' | 'primary' | 'secondary' | 'excel' | 'upload' | 'danger' | 'ghost' | 'stoplist';
export type ButtonSize = 'md' | 'sm';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: ButtonVariant;
    size?: ButtonSize;
    icon?: ReactNode;
    compact?: boolean;
    badge?: number;
}

export const Button: FC<ButtonProps> = ({
    variant = 'default',
    size = 'md',
    icon,
    badge,
    children,
    className,
    type = 'button',
    ...rest
}) => (
    <button
        type={type}
        className={cx(styles.btn, styles[variant], size === 'sm' && styles.sm, className)}
        {...rest}
    >
        {icon}
        {children}
        {badge !== undefined && badge > 0 && <span className={styles.badge}>{badge}</span>}
    </button>
);
